import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { AuthGuard } from "./auth-guard.service";
import { AuthService } from "./auth.service";
import CONFIGURATION from '../../configurations/configuration';

@Injectable()
export class AuthorizationGuard implements CanActivate {

  constructor(private authguard: AuthGuard, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.getMemberTypeCode() == CONFIGURATION.member_type_code?.investor) {
      return this.authguard._isInvestorRouteAccessible(state.url)
    }
    return this.authguard._isBorrowerRouteAccessible(state.url)
  }
}